import { Button, Grid2, TextField } from '@mui/material'
import React from 'react'
import Heading from '../../shared/utils/Heading'
import { useMutation } from '@tanstack/react-query';
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
// import api from '../../assets/api/usePostApi';
import { TextFormField } from '../../shared/components/FormFields/TextFormField';
import { useToaster } from '../../shared/utils/ToasterProvider';
import api from '../../assets/nodeApi/axiosInstance';



const SubscribeSection = ({content}) => {
    const { showToaster } = useToaster();
    const validationSchema = yup.object().shape({
        email: yup.string().email('Invalid email').required('Please Enter Your Email')
    });

    const initialValues = {
        email: ""
    };

    const mutation = useMutation({
        mutationFn: (formData) => api.post("/subscribers", formData),
    });

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        mutation.mutate(values, {
            onSuccess: (response) => {
                if (response?.data) {
                    showToaster('success', 'Thank You For Subscribing', 'success');
                } else {
                    showToaster('warning', 'Message sent, but no response from server.', 'warning');
                }

                resetForm();
            },
            onError: () => {
                showToaster('error', 'Error Occured While Subscribing', 'errro');

            },
            onSettled: () => {
                setSubmitting(false);
            }
        });
    };
    return (
        <Grid2 container spacing={2} sx={{ display: "flex", alignItems: "center" }}>
            <Grid2 children size={{ xs: 12, lg: 7 }}>
                <Heading Heading={content?.data?.subheading} SubHeading={content?.data?.heading} />
            </Grid2>
            <Grid2 container size={{ xs: 12, lg: 3.5 }} sx={{ display: "flex", justifyContent: "start", flexDirection: { xs: "row", md: "column" } }}>

                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {() => (
                        <Form>
                            <Grid2 container spacing={"15px"}>
                                <Grid2 children size={{ xs: 12, md: 12 }}>
                                    <Field
                                        name="email"
                                        component={TextFormField}
                                        placeholder={"Enter Your Mail ID"}
                                        isRequired={true}
                                    />

                                </Grid2>
                                <Grid2 children size={{ xs: 12, md: 12 }}>     <Button variant='contained' fullWidth type="submit">{content?.data?.buttonText}</Button></Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
                {/* <Grid2 children size={{ xs: 7, md: 12 }}>
                    <TextField
                        placeholder='Enter Your Mail ID'
                        fullWidth
                        sx={{
                            border: "0.5px solid #DC143C",
                            borderRadius: "12px",
                            "& fieldset": { border: "none" },
                            mb: 2,
                            py: { xs: "0px", sm: "0px" },
                            display: "flex",
                            alignItems: "center",
                            "& .MuiInputBase-input": {
                                typography: "body1",
                                padding: "10px 10px"

                            }
                        }}
                    />
                </Grid2>
                <Grid2 children size={{ xs: 4, md: 12 }}>     <Button variant='contained' fullWidth>Subscribe</Button></Grid2> */}

            </Grid2>

        </Grid2>
    )
}

export default SubscribeSection